<template>
  <!-- 使用指引文件导航按钮 -->
  <div class="container" @click="toGuidePage">
    <img class="file-search" src="@/assets/images/global/file-search.png" alt="" />
    <span>使用指引</span>
  </div>
</template>
<script>
export default {
  name: 'SearchFileButton',
  methods: {
    // 跳转到指引文件展示页面
    toGuidePage() {
      if (this.$route.path !== '/guidelines-for-video') {
        this.$router.push('/guidelines-for-video')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  position: fixed;
  right: 0;
  top: 50%;
  z-index: 999;
  background-color: #4393f5;
  width: 76px;
  height: 70px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 14px;
  cursor: pointer;

  .file-search {
    width: 20px;
    height: 23px;
    margin-bottom: 5.76px;
  }
}
</style>
